// extracted by mini-css-extract-plugin
var _1 = "EzaBWmPuCmFSwsy_aQy9";
var _2 = "QRJRm0ryDMkByFPNuGGg";
var _3 = "aGFh3QFVNdZnM7M6VRcW";
var _4 = "nN4XATedWhVYDd46tH7T";
var _5 = "lkL8RKTGQxDUzO_j20wf";
export { _1 as "bexley", _2 as "boardDivider", _3 as "eltham", _4 as "small", _5 as "thin" }
